import React, {Fragment} from 'react';
import {translate} from 'react-i18next';
import Node from "./node";
import Call from "../../../hocs/call";
import {showSuperUserLoginForm} from "../../../middlewares/authentication/actions";
import {
    addNodesConfigNode,
    changeNodesConfigConfig,
    changeNodesConfigNodeCollapsed,
    getNodesConfigConfig,
    hideNodesConfigMsds,
    readNodesConfigDefaultConfig,
    readNodesConfigMsds,
    removeNodesConfigNewNode,
    removeNodesConfigNode,
    setNodesConfigMsd,
    sortNodesConfigNode,
    submitNodesConfigNodeConfig
} from "./actions";
import {connect} from "react-redux";
import {compose} from "redux";
import {MARGIN_MD, MODAL_WIDTH_LG} from "../../../styles/constants";
import {Button, Col, Collapse, Divider, Modal, Row} from "antd";
import NodeCredentialsModal from "./NodeCredentialsModal";
import _ from 'lodash';
import {scrollTo} from '../../../middlewares/scrollTo/actions';
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import DragHandle from "../../../components/drag-handle";
import EnhancedModal from "../../../components/enhanced-modal";
import {getUrnFromArtefact} from "../../../utils/sdmxJson";
import ArtefactList from "../../../components/artefact-list";
import {isDictionaryValid} from "../../../utils/artefactValidators";

const mapStateToProps = state => ({
    dataLangs: state.config.dataManagement.dataLanguages,
    config: state.scenes.configuration.nodesConfig.config,
    superUserUsername: state.app.superUser.username,
    isMsdsVisible: state.scenes.configuration.nodesConfig.isMsdsVisible,
    msds: state.scenes.configuration.nodesConfig.msds,
    defaultConfig: state.scenes.configuration.nodesConfig.defaultConfig
});

const mapDispatchToProps = dispatch => ({
    onChange: config => dispatch(changeNodesConfigConfig(config)),
    onNodeAdd: dataLangs => dispatch(addNodesConfigNode(dataLangs)),
    onNewNodeRemove: index => dispatch(removeNodesConfigNewNode(index)),
    onNodeRemove: (index, nodeId) => dispatch(removeNodesConfigNode(index, nodeId)),
    onNodeSubmit: (nodeConfig, username, password) =>
        dispatch(submitNodesConfigNodeConfig(nodeConfig, username, password)),
    onNodeSort: orderedNodes => dispatch(sortNodesConfigNode(orderedNodes)),
    showConfigurationSuperUserLoginForm: () => dispatch(showSuperUserLoginForm()),
    scrollToLastNewNode: lastNewNodeElement => dispatch(scrollTo(lastNewNodeElement)),
    onNodeCollapsedChange: (nodeIndex, collapsed) => dispatch(changeNodesConfigNodeCollapsed(nodeIndex, collapsed)),
    fetchConfig: () => dispatch(getNodesConfigConfig()),
    onMsdsHide: () => dispatch(hideNodesConfigMsds()),
    fetchMsds: () => dispatch(readNodesConfigMsds()),
    onMsdSet: obj => dispatch(setNodesConfigMsd(obj)),
    fetchDefaultConfig: () => dispatch(readNodesConfigDefaultConfig()),
});

class NodesConfig extends React.Component {

    componentDidUpdate(prevProps) {

        if (prevProps.config && this.props.config && prevProps.config.length < this.props.config.length) {

            const nodeCards = document.getElementsByClassName("nodes-config__node");

            this.props.scrollToLastNewNode(nodeCards[nodeCards.length - 1]);
        }
    }


    render() {
        const {
            t,
            dataLangs,
            config,
            superUserUsername,
            defaultConfig,
            onNodeAdd,
            onNodeRemove,
            onNewNodeRemove,
            onChange,
            showConfigurationSuperUserLoginForm,
            onNodeSubmit,
            onNodeSort,
            onNodeCollapsedChange,
            fetchConfig,
            fetchDefaultConfig,
            isMsdsVisible,
            msds,
            onMsdsHide,
            fetchMsds,
            onMsdSet
        } = this.props;

        const generalDefinitionIsWrong = (general) => {
            return (
                !general ||
                !general.ID || !general.Name || !general.DefaultItemsViewMode
            )
        }
        const agenciesDefinitionIsWrong = (agencies) => {
            return (
                !agencies ||
                (agencies || []).some(ag => !ag.Id || (ag.Id || "").trim().length === 0 || !isDictionaryValid(ag.Name))
            );
        }
        const endpointDefinitionIsWrong = (endpoint) => {
            return (
                !endpoint ||
                !endpoint.NSIEndpoint || (endpoint.NSIEndpoint || "").trim().length === 0 ||
                (endpoint.NSIReadOnlyUsername && !endpoint.NSIReadOnlyPassword) ||
                (!endpoint.NSIReadOnlyUsername && endpoint.NSIReadOnlyPassword) ||
                !endpoint.NSIEndpointType ||
                !endpoint.PingArtefact
            );
        }
        const annotationTabsDefinitionIsWrong = (annotationTabs) => {
            return (
                !annotationTabs ||
                annotationTabs.Tabs.filter(
                    at => !at.Name || !at.Annotations ||
                        at.Annotations.filter(a => !a.Name).length > 0
                ).length > 0
            );
        }
        const proxyDefinitionIsWrong = (proxy) => {
            return (
                !proxy ||
                (
                    proxy.Enabled &&
                    (
                        !proxy.Address || !proxy.Port ||
                        ((proxy.Username && !proxy.Password) || (!proxy.Username && proxy.Password))
                    )
                )

            );
        }
        const searchDefinitionIsWrong = (search) => {
            return (
                !search ||
                search.ExcludeCodelists.filter(ex => !ex).length ||
                search.ExcludeConceptSchemes.filter(ex => !ex).length
            );
        }
        const annotationsDefinitionIsWrong = (annotations) => {
            if (!annotations) {
                return true;
            }
            let hasWrongAnnotation = false;
            Object.values(annotations).forEach(ann => {
                if (!ann || (ann.Id || "").trim().length === 0 || (ann.Type || "").trim().length === 0) {
                    hasWrongAnnotation = true;
                }
            });

            if (hasWrongAnnotation) {
                return true;
            }

            const defaultAnnotation = annotations.Default
            return (
                !defaultAnnotation ||
                (defaultAnnotation.TimePeriodStart || "").trim().length === 0 ||
                (defaultAnnotation.TimePeriodEnd || "").trim().length === 0 ||
                (defaultAnnotation.LastNObservation || "").length === 0 ||
                (defaultAnnotation.LastNPeriod || "").trim().length === 0
            );

        }
        const databrowserDefinitionIsWrong = (dataBrowser) => {
            return (
                    !dataBrowser ||
                    (
                        dataBrowser.Enable &&
                        (
                            (dataBrowser.URL || "").trim().length === 0 ||
                            (dataBrowser.NodeID || "").trim().length === 0 ||
                            (dataBrowser.Password || "").trim().length === 0
                        )
                    ) ||
                    (
                        (dataBrowser.DataBrowserUrl || dataBrowser.Enable) &&
                        (dataBrowser.NodeID || "").trim().length === 0)
                ) ||
                (
                    dataBrowser.Enable && dataBrowser.HTTPAuthEnable &&
                    (
                        (dataBrowser.HTTPAuthUsername || "").trim().length === 0
                    )
                ) ||
                (
                    dataBrowser.Enable && dataBrowser.ProxyEnable &&
                    (
                        (dataBrowser.ProxyURL || "").trim().length === 0 ||
                        (String(dataBrowser.ProxyPort) || "").trim().length === 0
                    )
                )
        }

        const nodeDefinitionIsWrong = (node) => {
            return (
                !node ||
                generalDefinitionIsWrong(node.General) ||
                agenciesDefinitionIsWrong(node.Agencies) ||
                endpointDefinitionIsWrong(node.Endpoint) ||
                annotationTabsDefinitionIsWrong(node.AnnotationTabs) ||
                proxyDefinitionIsWrong(node.Proxy) ||
                searchDefinitionIsWrong(node.Search) ||
                annotationsDefinitionIsWrong(node.Annotations) ||
                databrowserDefinitionIsWrong(node.DataBrowser)
            )
        };

        return (
            <Fragment>
                <Call cb={showConfigurationSuperUserLoginForm} disabled={superUserUsername !== null}>
                    {superUserUsername && (
                        <Call cb={fetchConfig} disabled={config !== null || defaultConfig === null}>
                            <Call cb={fetchDefaultConfig} disabled={defaultConfig !== null}>
                                {(config !== null && defaultConfig !== null) && (
                                    <Fragment>
                                        <Button onClick={() => onNodeAdd(dataLangs)} type="primary" icon="plus"
                                                style={{marginBottom: MARGIN_MD}}>
                                            {t('scenes.configuration.nodesConfig.buttons.addNode.title')}
                                        </Button>
                                        <DragDropContext
                                            onDragEnd={
                                                ({source: src, destination: dest}) => {

                                                    const moved = _.cloneDeep(config[src.index]);
                                                    let orderedNodes = _.cloneDeep(config).filter((node, index) => index !== src.index);
                                                    orderedNodes = [
                                                        ...orderedNodes.slice(0, dest.index),
                                                        moved,
                                                        ...orderedNodes.slice(dest.index),
                                                    ];

                                                    onNodeSort(orderedNodes);
                                                }
                                            }
                                        >
                                            <Droppable droppableId="droppable">
                                                {(provided) => (
                                                    <div
                                                        {...provided.droppableProps}
                                                        ref={provided.innerRef}
                                                    >
                                                        {config.map((node, key) =>
                                                            <Draggable key={key} draggableId={`${key}`} index={key}>
                                                                {(provided) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                    >
                                                                        <Collapse
                                                                            className="nodes-config__node"
                                                                            key={key}
                                                                            activeKey={'expanded'}
                                                                            onChange={() => onNodeCollapsedChange(key, !node.isCollapsed)}
                                                                        >
                                                                            <Collapse.Panel
                                                                                key={node.isCollapsed ? 'collapsed' : 'expanded'}
                                                                                header={
                                                                                    <Row justify="space-between"
                                                                                         type="flex">
                                                                                        <Col>
                                                                                                <span {...provided.dragHandleProps}>
                                                                                                  <DragHandle/>
                                                                                                </span>
                                                                                            {
                                                                                                node.isNewNode
                                                                                                    ? t('scenes.configuration.nodesConfig.newNodeCard.title')
                                                                                                    : (node.General && node.General.Name) || t('scenes.configuration.nodesConfig.noNameNodeCard.title')
                                                                                            }
                                                                                        </Col>
                                                                                        <Col>
                                                                                            <Button
                                                                                                size="small"
                                                                                                icon="delete"
                                                                                                title={t("scenes.configuration.nodesConfig.buttons.removeNode.title")}
                                                                                                style={{marginRight: 8}}
                                                                                                onClick={
                                                                                                    event => {
                                                                                                        Modal.confirm({
                                                                                                            title: node.isNewNode
                                                                                                                ? t("scenes.configuration.nodesConfig.modals.deleteConfirm.title_newNode")
                                                                                                                : t("scenes.configuration.nodesConfig.modals.deleteConfirm.title", {
                                                                                                                    id: node.General.ID
                                                                                                                }),
                                                                                                            onOk() {
                                                                                                                node.isNewNode
                                                                                                                    ? onNewNodeRemove(key)
                                                                                                                    : onNodeRemove(key, node.General.ID)
                                                                                                            },
                                                                                                            cancelText: t('commons.buttons.cancel.title')
                                                                                                        });
                                                                                                        event.stopPropagation();
                                                                                                    }
                                                                                                }
                                                                                            />
                                                                                        </Col>
                                                                                    </Row>
                                                                                }
                                                                            >
                                                                                <Node
                                                                                    node={node}
                                                                                    onChange={
                                                                                        node => {
                                                                                            let newConfig = _.cloneDeep(config);
                                                                                            const customizer = (_, src) => {
                                                                                                if (Array.isArray(src))
                                                                                                    return src;
                                                                                                else {
                                                                                                    return undefined;
                                                                                                }
                                                                                            };
                                                                                            _.mergeWith(newConfig[key], node, customizer);
                                                                                            onChange(newConfig);
                                                                                        }
                                                                                    }
                                                                                    index={key}
                                                                                />
                                                                                <Divider/>
                                                                                <Button
                                                                                    disabled={nodeDefinitionIsWrong(node)}
                                                                                    type="primary"
                                                                                    onClick={
                                                                                        () => {

                                                                                            let duplicateAnnotationName;
                                                                                            let annotationNames = [];

                                                                                            node.AnnotationTabs.Tabs.forEach(({Annotations}) => {
                                                                                                if (!duplicateAnnotationName) {

                                                                                                    Annotations.forEach(({Name}) => {
                                                                                                        if (!duplicateAnnotationName) {

                                                                                                            if (annotationNames.includes(Name)) {
                                                                                                                duplicateAnnotationName = Name;
                                                                                                            } else {
                                                                                                                annotationNames.push(Name);
                                                                                                            }

                                                                                                        }
                                                                                                    });

                                                                                                }
                                                                                            });

                                                                                            if (config.filter((otherNode, index) => index !== key && otherNode.General.ID === node.General.ID).length) {
                                                                                                Modal.warning({
                                                                                                    title: t('scenes.configuration.nodesConfig.existsIdWarning.title'),
                                                                                                })
                                                                                            } else if (duplicateAnnotationName) {
                                                                                                Modal.warning({
                                                                                                    title: t('scenes.configuration.nodesConfig.duplicateAnnotationNameWarning.title',
                                                                                                        {name: duplicateAnnotationName})
                                                                                                })
                                                                                            } else if (
                                                                                                ((node.Endpoint.MAEndpoint || "").length === 0) &&
                                                                                                ((node.Endpoint.DMEndpoint || "").length === 0)
                                                                                            ) {
                                                                                                onNodeSubmit(node, null, null);
                                                                                            } else {
                                                                                                let modal = Modal.info();
                                                                                                modal.update({
                                                                                                    icon: 'lock',
                                                                                                    title: t('scenes.configuration.nodesConfig.nodeCredentialsModal.title'),
                                                                                                    content:
                                                                                                        <NodeCredentialsModal
                                                                                                            t={t}
                                                                                                            modal={modal}
                                                                                                            onSubmit={(username, password) => onNodeSubmit(node, username, password)}
                                                                                                        />,
                                                                                                    okButtonProps: {style: {display: 'none'}},
                                                                                                    keyboard: false
                                                                                                });
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                >
                                                                                    {t('commons.buttons.save.title')}
                                                                                </Button>
                                                                            </Collapse.Panel>
                                                                        </Collapse>
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        )}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </Fragment>
                                )}
                            </Call>
                        </Call>
                    )}
                </Call>
                <EnhancedModal
                    visible={isMsdsVisible}
                    onCancel={onMsdsHide}
                    title={t('scenes.configuration.nodesConfig.modals.msdList.title')}
                    width={MODAL_WIDTH_LG}
                    footer={<Button onClick={onMsdsHide}>{t('commons.buttons.close.title')}</Button>}
                >
                    <Call cb={fetchMsds} disabled={!isMsdsVisible}>
                        <ArtefactList
                            artefacts={msds}
                            onRowClick={artefact => onMsdSet(getUrnFromArtefact(artefact))}
                        />
                    </Call>
                </EnhancedModal>
            </Fragment>
        )
    }
}


export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(NodesConfig);
